import React from 'react'
import { GlassMorphIcon } from '@/components/ui'
import { FundingBannerFormWrapper } from '../FundingBannerFormWrapper'
import type { TFundingBannerResultProps } from './types'
import './styles.scss'

export const FundingBannerResult = ({ glassMorphIcon, title, subTitle, buttons }: TFundingBannerResultProps) => {
  return (
    <FundingBannerFormWrapper className="fundingBannerResult">
      <GlassMorphIcon image={glassMorphIcon} className="fundingBannerResult__icon" />
      <h2 className="fundingBannerResult__title">{title}</h2>
      <div className="fundingBannerResult__subTitle">{subTitle}</div>
      <div className="fundingBannerResult__buttons">{buttons}</div>
    </FundingBannerFormWrapper>
  )
}
